import { buildWhereFromFilters } from '../sql/buildWhereFromFilters';
import { buildWhereByModule } from '../sql/buildWhereByModule';
import { AttributesFilterInputInterface } from '../interfaces/AttributesFilterInputInterface';
import { ModuleEnum } from '../enums/ModuleEnum';
import { LocalesEnum } from '../enums/LocalesEnum';
import { prepareValuesMapping } from '../sql/prepareValuesMapping';
import { buildUniqueValuesSql } from '../sql/buildUniqueValuesSql';

export function valuesQuery(
    id: string,
    filter: AttributesFilterInputInterface,
    module: ModuleEnum,
    labels: string[],
    rawName: LocalesEnum,
    from: string,
    skipAttr: string[],
    discontinuedAttr: string,
): [string, string[]] {

  const {
      exclude,
      localized,
      attrValue
  } = prepareValuesMapping(id, rawName, skipAttr);

  const [whereModule, paramsModule] = buildWhereByModule(module, rawName, discontinuedAttr);
  const [whereFilter, paramsFilter] = buildWhereFromFilters(filter, exclude, rawName);
  const sql = buildUniqueValuesSql(
      localized,
      attrValue,
      from,
      `${whereModule}
    ${whereFilter.length > 0 ? ` AND ${whereFilter}` : ''}
    ${labels.length ? ` AND label IN (${labels.map(() => '?').join(',')})` : ''}`
  )
    return [sql, [...paramsModule, ...paramsFilter, ...labels]];
}


